import { Service } from '@genial/services';

import { screenName } from '../../../store/batchTicketInvestLink/constants';
import { addAuthorizationHeader } from '../Constants';
import { PatchBasketCustomerOffers, RefuseBasketCustomerOffer } from '../utils/types';

export const patchCustomerOffer = async ({
  customerOffers,
  basketCustomerOrderId,
  jwtToken,
}: PatchBasketCustomerOffers) => {
  try {
    await Service.Basket.V1.patchBasketCustomerByOffers(
      {
        screenName,
        basketCustomerOrderId,
        updateCustomerBasketOffersRequest: {
          customerOffers,
        },
      },
      addAuthorizationHeader(jwtToken)
    );
  } catch (error) {
    throw new Error(error as never);
  }
};

export const cancelCustomerOffer = async ({
  basketCustomerOrderId,
  jwtToken,
}: RefuseBasketCustomerOffer) => {
  try {
    await Service.Basket.V1.patchBasketCustomerByCustomerNotInterested(
      {
        screenName,
        basketCustomerId: basketCustomerOrderId,
      },
      addAuthorizationHeader(jwtToken)
    );
  } catch (error) {
    throw new Error(error as never);
  }
};
